import { CircularProgress } from "@mui/material";
import Icon from "assets/images/settings/billingNew.svg";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomTabs from "../../CustomTabs";
import TextView from "../../TextView";
import { SubscriptionPage } from "../Subscription/index";
import { BillingForm } from "./BillingForm";
import {
  BillingTitle,
  CenterWrapper,
  Content,
  ContentHeader,
  HeaderIcon,
  LoadingContainer,
} from "./styles";
import { getActiveSubscriptionData } from "../../../redux/selectors/subscriptionSelectors";
import { UpcomingSubscriptionBox } from "../../SubscriptionModals/SharedComponents";
import CouponDisplay from "../../CouponDisplay";

export const BillingsPage = () => {
  const [value, setValue] = useState(0);
  const { data, loading } = useSelector(getActiveSubscriptionData);
  const [activePlan, setActivePlan] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Only block the page when subscription has never loaded. Background
  // refetches (e.g. useSubscriptionSync on window focus) set loading=true but
  // keep data — unmounting tabs here would remount BillingForm and re-fetch
  // transactions/cards on every tab focus.
  const subscriptionInitialLoad = loading && data == null;

  useEffect(() => {
    if (data) setActivePlan(data.price.duration);
  }, [data]);

  return (
    <CenterWrapper>
      <ContentHeader>
        <HeaderIcon src={Icon} />
        <BillingTitle>
          <TextView variant="title">Subscription & Billing</TextView>
          <TextView variant="subtitle">
            Manage your subscription & billing information.
          </TextView>
        </BillingTitle>
      </ContentHeader>
      {/* Upcoming subscription change notification */}
      <UpcomingSubscriptionBox />

      {value === 0 && (
        <div style={{ marginBottom: "20px", marginTop: "20px" }}>
          <CouponDisplay />
        </div>
      )}

      <Content>
        <CustomTabs
          value={value}
          onChange={handleChange}
          tabs={["Subscription", "Billing"]}
        />

        {subscriptionInitialLoad ? (
          <LoadingContainer>
            <CircularProgress />
          </LoadingContainer>
        ) : value === 0 ? (
          <SubscriptionPage activePlan={activePlan} />
        ) : (
          <BillingForm openSubscriptionTab={() => setValue(0)} />
        )}
      </Content>
    </CenterWrapper>
  );
};
